import React, { ReactElement } from 'react'
import { BasketItemModel } from './types/models'

type CuttingInstructionsProps = {
  item: BasketItemModel;
  onCuttingInstructionsChanged: (
    item: BasketItemModel, instructions: string, offcutsRequired: boolean,
  ) => void;
}

const CuttingInstructions = (
  { item, onCuttingInstructionsChanged }: CuttingInstructionsProps
): ReactElement => {
  if (!item.product.cuttable) {
    return null
  }

  return (
    <>
      <div className="basket-item-cutting-instructions">
        <label htmlFor={`cutting_instructions_${item.product.id}`}>Cutting Instructions</label>
        <textarea
          id={`cutting_instructions_${item.product.id}`}
          className="new-cutting-instructions"
          cols={20}
          rows={2}
          placeholder="Add your cutting instructions here"
          value={item.cutting_instructions}
          onChange={(e): void => onCuttingInstructionsChanged(
            item, e.target.value, item.offcuts_required
          )}
        ></textarea>
      </div>
      <div className="basket-item-offcuts">
        Offcuts Required?
        <div className="offcuts-radio-btns">
          <label className="offcuts-required-label">
            <input name={`offcuts_${item.id}`} value="Yes" type="radio" checked={item.offcuts_required} onChange={(): void => onCuttingInstructionsChanged(item, item.cutting_instructions, !item.offcuts_required)} />
            Yes
          </label>
          <label className="offcuts-required-label">
            <input name={`offcuts_${item.id}`} value="No" type="radio" checked={!item.offcuts_required} onChange={(): void => onCuttingInstructionsChanged(item, item.cutting_instructions, !item.offcuts_required)} />
            No
          </label>
        </div>
      </div>
    </>
  )
}

export default CuttingInstructions
